import { Button } from "@/components/ui/button";
import { QuantityStepper } from "@/components/supplement/QuantityStepper";
import { COUNTRY_LABELS, STAGE_LABELS } from "@/components/supplement/supplementConstants";

export const ProfileStep = ({ screening, profile, onChange, onNext }) => {
  const age = Number(profile.age);
  const weight = Number(profile.weight_kg);
  const valid = Boolean(
    profile.country
      && profile.stage
      && Number.isFinite(age)
      && age >= 30
      && age <= 70
      && Number.isFinite(weight)
      && weight >= 30
      && weight <= 200,
  );
  const numericInvalid = (profile.age !== "" && (!Number.isFinite(age) || age < 30 || age > 70))
    || (profile.weight_kg !== "" && (!Number.isFinite(weight) || weight < 30 || weight > 200));

  return (
    <section className="supplement-tool" data-testid="supplement-profile-step">
      <div className="supplement-fields">
        <label htmlFor="supplement-country">
          <span>Country</span>
          <select id="supplement-country" value={profile.country} onChange={(event) => onChange("country", event.target.value)} data-testid="supplement-country-select">
            <option value="" />
            {screening.profile_inputs[0].options.map((value) => <option key={value} value={value}>{COUNTRY_LABELS[value]}</option>)}
          </select>
        </label>
        <div className="supplement-quantity-field" data-testid="supplement-age-field">
          <span>Age</span>
          <QuantityStepper id="supplement-age" label="age" value={age} min={30} max={70} onChange={(value) => onChange("age", value)} />
        </div>
        <div className="supplement-quantity-field" data-testid="supplement-weight-field">
          <span>Weight</span>
          <QuantityStepper id="supplement-weight" label="weight" value={weight} min={30} max={200} unit="kg" onChange={(value) => onChange("weight_kg", value)} />
        </div>
        <label htmlFor="supplement-stage">
          <span>Menopause stage</span>
          <select id="supplement-stage" value={profile.stage} onChange={(event) => onChange("stage", event.target.value)} data-testid="supplement-stage-select">
            <option value="" />
            {screening.profile_inputs[3].options.map((value) => <option key={value} value={value}>{STAGE_LABELS[value]}</option>)}
          </select>
        </label>
      </div>
      {numericInvalid && <p className="supplement-error" role="alert" data-testid="supplement-profile-error">Please check this number.</p>}
      <div className="supplement-actions supplement-actions--end">
        <Button onClick={onNext} disabled={!valid} className="supplement-primary-action" data-testid="supplement-profile-next-button">Next</Button>
      </div>
    </section>
  );
};